import { Box, CardMedia } from "@mui/material"
import theme from "@skistarab/mui-theme"

import useResponsiveImage from "@/hooks/useResponsiveImage"
import { MemberInformation } from "@/queries/models/Product"

import MemberBenefitBadge from "../../MemberBenefitBadge"
import NoteBadge from "../cardOverlays/NoteBadge"
import UnavailableOverlay from "../cardOverlays/UnavailableOverlay"

const { md, lg } = theme.breakpoints.values

const SIZES = [
  `(min-width: ${lg}px) calc((100vw - 144px) / 3)`,
  `(min-width: ${md}px) calc((100vw - 112px) / 2)`,
  "calc(100vw - 48px)",
].join(", ")

type ProductCardMediaProps = {
  imageId: number
  productName: string
  actionNote?: string
  memberInformation?: MemberInformation
  statusText?: string
  topBadge?: React.ReactNode
}

const ProductCardMedia = ({
  imageId,
  productName,
  actionNote,

  memberInformation,
  statusText,
  topBadge,
}: ProductCardMediaProps) => {
  const { imageUrl, srcSet } = useResponsiveImage(imageId)
  const hasMemberInfo = Boolean(memberInformation?.memberLevel.key)
  return (
    <Box
      sx={{
        width: "100%",
        flexShrink: 0,
        padding: 1,
        pb: 0,
        position: "relative",
      }}
    >
      <Box sx={{ position: "relative" }}>
        <CardMedia
          component="img"
          image={imageUrl}
          srcSet={srcSet}
          sizes={SIZES}
          alt={productName}
          sx={{
            height: "auto",
            aspectRatio: "2 / 1",
            margin: 0,
            width: "100%",
            objectFit: "cover",
            borderBottomLeftRadius: hasMemberInfo ? 0 : undefined,
            borderBottomRightRadius: hasMemberInfo ? 0 : undefined,
          }}
        />

        {actionNote && (
          <NoteBadge
            text={actionNote}
            position="bottom-left"
            backgroundColor="grey.900"
          />
        )}

        {topBadge && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              mr: 5,
            }}
          >
            {topBadge}
          </Box>
        )}
      </Box>
      {hasMemberInfo && (
        <MemberBenefitBadge
          memberLevelName={memberInformation!.memberLevel.name}
          memberLevelKey={memberInformation!.memberLevel.key}
          description={memberInformation!.memberLevel.description}
        />
      )}

      {statusText && (
        <UnavailableOverlay
          statusText={statusText}
          borderRadius={hasMemberInfo ? "4px 4px 0 0" : 1}
        />
      )}
    </Box>
  )
}

export default ProductCardMedia
